module.exports = __webpack_public_path__ + "img/marker-yellow.3dd18a31.svg";